export const languageProgress = [
  { id: 1, name: 'HTML', value: 95 },
  { id: 2, name: 'Express', value: 95 },
  { id: 3, name: 'Javascript', value: 90 },
  { id: 4, name: 'NodeJs', value: 90 },
  { id: 5, name: 'CSS', value: 85 },
  { id: 6, name: 'MongoDB', value: 85 },
];
